import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { Icon } from '@/components/shared/icon';
export type TagStatus = 'active' | 'inactive' | 'pending' | 'error';
export interface TagColors {
  color: string;
  backgroundColor: string;
}
export const StatusTag = t0 => {
  const $ = _c(14);
  const {
    status,
    label,
    icon,
    colors
  } = t0;
  const defaultBackgroundColor = status === "active" ? "var(--mui-palette-custom-LIGHT-GREEN-OPACITY-20)" : status === "inactive" ? "var(--mui-palette-custom-GREY-OPACITY)" : status === "pending" ? "var(--mui-palette-custom-ORANGE-07)" : "var(--mui-palette-background-default)";
  const defaultColor = status === "active" ? "var(--mui-palette-custom-DARK-GREEN-01)" : status === "inactive" ? "var(--mui-palette-custom-GREY-01)" : status === "pending" ? "var(--mui-palette-custom-ORANGE-01)" : "var(--mui-palette-custom-GREY-01)";
  const backgroundColor = colors?.backgroundColor ?? defaultBackgroundColor;
  const color = colors?.color ?? defaultColor;
  let t1;
  if ($[0] !== backgroundColor) {
    t1 = {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "4px 12px 4px 4px",
      borderRadius: "4px",
      backgroundColor
    };
    $[0] = backgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color || $[3] !== icon) {
    t2 = <Icon color={color} iconClass={icon} />;
    $[2] = color;
    $[3] = icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== color) {
    t3 = {
      "&&&": {
        color,
        fontWeight: 500
      }
    };
    $[5] = color;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== label || $[8] !== t3) {
    t4 = <Typography variant="subtitle1Strong" noWrap={true} sx={t3}>{label}</Typography>;
    $[7] = label;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <Stack direction="row" sx={t1}>{t2}{t4}</Stack>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};